const Plus = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11 13v7h2v-7h7v-2h-7V4h-2v7H4v2h7z" fill="#000" />
    </svg>
)

export default Plus;